// extracted by mini-css-extract-plugin
export default {"container":"b0-z","list":"c0-z"};